import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

import imageOne from "../../resource/hermitage/maintance/1.png";
import imageThree from "../../resource/hermitage/maintance/2.png";

import imageFour from '../../resource/hermitage/maintance/1.jpeg'
import imageFive from '../../resource/hermitage/maintance/2.jpg'
import imageSix2 from '../../resource/hermitage/maintance/3.jpg'



import imageFour1 from '../../resource/hermitage/maintance/3.png'
import imageFive1 from '../../resource/hermitage/maintance/4.png'

import imageSix from "../../resource/hermitage/maintance/5.png";
import TitleChnage from "../../Hook/TitleChnage";




const MaintenanceHermitage = () => {
  TitleChnage("Maintenance ")
    const navigate = useNavigate();
            const handleClick = (event) => {
                const pathMap = {
                  maintananceRequest:"/maintananceRequest"
                };
            
                const path = event.currentTarget.id;
                const targetPath = pathMap[path];
            
                if (targetPath) {
                  navigate(targetPath);
                }
              };
  return (
    <div className="hermitageMaintennace-page inside-pages">
    <div className="right-box">
      <img
        src={imageOne}
        alt="Right Top Image"
        className="right-image"
        width={300}
      />
    </div>

    <h1 className="font-main dark-gold p-4 mt-4">Maintenance of the Monastery
    </h1>
    <h3 className="font-second p-4 mt-4">
    Volunteer Opportunities

    </h3>
    <p className="h4 dark-gold p-4 mt-4">
    Bhaddeka Vihari Monastery and Retreat Center is dedicated to serve the Sangha and the broader community. Situated on 42 acres of land, the premises include the Sangha Residence, Meditation Hall, Dana Hall with kitchen, several cottages, Kutis, and toilet facilities. These buildings and surroundings are extensively utilized by the Sangha, retreatants, devotees, and meal donors. Typically, ten members of the Sangha and two laities reside here, and at least four residential retreats, occur each month.

    </p>

    <p className="h4 dark-gold p-4 mt-4">Given the extensive use of the facilities, maintaining the grounds and buildings is a significant task. The Monastery and Retreat Center offer numerous opportunities for volunteers to contribute their skills, knowledge, and strengths to these essential maintenance tasks. The ongoing maintenance and new project work create a rich environment for meaningful participation, and all contributions are highly valued and appreciated</p>
    <h3 className="font-second p-4 mt-5">
    Upcoming Maintenance

    </h3>
  
    <p className="h4 dark-gold p-4 mt-5">The Bhaddeka Vihari Monastery and Meditation Center currently operates three cottages that have been extensively used by devotees since its establishment in 2017. To maintain a welcoming environment, these cottages require renovations within the upcoming year. Specifically, repairs are needed for rotting walls, including repainting, curtain restoration, and various internal improvements 
    </p>
    <p className="h4 dark-gold p-4 mt-5">Furthermore, the external surroundings require maintenance, including cleaning, deck repairs, painting, and weed removal. We kindly invite volunteers, either individuals or groups, to assist with the maintenance of these cottages. Depending on their skills, capabilities, and availability, volunteers may contribute to specific tasks such as painting walls, repairing decks, and removing weeds.</p>
    <p className="h4 dark-gold p-4 mt-5">By ensuring these cottages remain in good condition, volunteers play a significant role in supporting the Dhamma community, enhancing the experience of those residing within the monastery while fostering a positive environment enriched by blessings and well-wishing from practitioners.</p>
    <p className="h4 dark-gold p-4 mt-5">If you wish to provide necessary items for this maintenance work, please inform the Bhaddeka Vihari Monastery and Meditation Center office</p>
    <p className="h4 dark-gold p-4 mt-5">For those wishing to contribute financially to the renovation of the cottages, monetary donations will be greatly appreciated. Funds will be allocated toward purchasing essential supplies for maintenance tasks, including wall paint, wooden planks, tools, and other necessary materials.</p>
    <p className="h4 dark-gold p-4 mt-5">If you wish to make a monetary donation, please see the details at the end of this page.
If you are interested in donating supplies, please contact the Bhaddeka Vihari Monastery and Meditation Center office.
</p>
<p className="h4 dark-gold p-4 mt-5">Thank you for considering your support in reinforcing the Monastery’s commitment to providing a serene and nurturing space for spiritual practice.</p>

<img src={imageFour} alt="" className="mt-6" style={{ width: "100%" }} />



    <h1 className="font-second dark-gold p-4 mt-6 ">Regular Maintenance</h1>
    <p className="h4 dark-gold p-4 mt-4 ">The Bhaddeka Vihari Monastery and Meditation Center requires regular maintenance. For convenience, the following list outlines common types of work available, though any additional expertise or capacity to assist in other areas is also welcome.


    </p>

    
      <h3 className="font-second p-4 mt-5">
      Sangha Residence

    </h3>
    <p className="h4 dark-gold p-4 mt-5 ">1.	Buddha Kuti/Shrine room cleaning (Steam clean carpet floors once every three months)
    </p>
    <p className="h4 dark-gold p-4 mt-5 ">2.	Window cleaning (once every three months)
    </p>
    <p className="h4 dark-gold p-4 mt-5 ">3.	Roof gutter cleaning (twice a year)
    </p>
    <p className="h4 dark-gold p-4 mt-5 ">4.	Outer passageway cleaning (once every three months)
    </p>
    <p className="h4 dark-gold p-4 mt-5 ">5.	Wet area cleaning
    </p>
     


    <h3 className="font-second p-4 mt-5">
    Dhamma Hall
    </h3>
    <p className="h4 dark-gold p-4 mt-5 ">1. Floor cleaning (Steam clean carpet strips)
    </p>
    <p className="h4 dark-gold p-4 mt-5 ">2. Windows cleaning (once every three months)
    </p>
    <p className="h4 dark-gold p-4 mt-5 ">3. Roof gutters cleaning (twice a year)
    </p>
    <p className="h4 dark-gold p-4 mt-5 ">4. Outer passageway cleaning (once every three months)
    </p>

   

    <h3 className="font-second p-4 mt-5">
    Dana Hall
    </h3>
    <p className="h4 dark-gold p-4 mt-5 ">1. Floor tile area cleaning
    </p>
    <p className="h4 dark-gold p-4 mt-5 ">2. Kitchen equipment and cupboard cleaning
    </p>
    <p className="h4 dark-gold p-4 mt-5 ">3. Roof gutters cleaning (twice a year)
    </p>
    <p className="h4 dark-gold p-4 mt-5 ">4. Wet area cleaning
    </p>

    <img src={imageFive} alt="" className="mt-6" style={{ width: "100%" }} />


    <h3 className="font-second p-4 mt-5">
    Cottages and Kutis (Three Cottages and 26 Individual Kutis)
    </h3>
    <p className="h4 dark-gold p-4 mt-5 ">1. Floor cleaning (once a month)
    </p>
    <p className="h4 dark-gold p-4 mt-5 ">2. Windows cleaning (once a month)
    </p>
    <p className="h4 dark-gold p-4 mt-5 ">3. Roof gutters cleaning (twice a year)
    </p>
    <p className="h4 dark-gold p-4 mt-5 ">4. Outer passageway cleaning (once every three months)
    </p>
    <p className="h4 dark-gold p-4 mt-5 ">5. Wet area cleaning
    </p>

  


    <h3 className="font-second p-4 mt-5">
    Paths and Green Areas
    </h3>
    <p className="h4 dark-gold p-4 mt-5 ">1. Path cleaning 
    </p>
    <p className="h4 dark-gold p-4 mt-5 ">2. Grass cutting (once a month)
    </p>
    <p className="h4 dark-gold p-4 mt-5 ">3. Tree and plant pruning (as needed)
    </p>
    <p className="h4 dark-gold p-4 mt-5 ">4. Flower garden and pots maintenance
    </p>

    <h3 className="font-second p-4 mt-5">
    Common Facilities
    </h3>
    <p className="h4 dark-gold p-4 mt-5 ">1.	Store room cleaning and organization
    </p>
    <p className="h4 dark-gold p-4 mt-5 ">2.	Toilet and wet area cleaning
    </p>
    <p className="h4 dark-gold p-4 mt-5 ">3.	Garage cleaning
    </p>

    <h3 className="font-second p-4 mt-5">
    Other Ongoing Volunteer Tasks
    </h3>
    <p className="h4 dark-gold p-4 mt-5 ">1.	Organizing retreats
    </p>
    <p className="h4 dark-gold p-4 mt-5 ">2.	Dhamma service during retreats
    </p>
    <p className="h4 dark-gold p-4 mt-5 ">3.	Caregiver for the Sangha
    </p>
    

    <img src={imageSix2} alt="" className="mt-6" style={{ width: "100%" }} />

    <p className="h4 dark-gold p-4 mt-4">We warmly invite all generous hands and minds to join us in these efforts. Your support is crucial to the continued success and upkeep of the Monastery and its community.</p>
    <p className="h4 dark-gold p-4 mt-4">Individually or as a group, you are welcome to take responsibility for maintaining any of the buildings or facilities, or assisting with ongoing tasks such as maintaining the Sangha Residence, Dhamma Hall, Dana Hall, a cottage, or a Kuti, or cleaning roof gutters. Your voluntary contribution is greatly appreciated in every possible way.</p>

    <p className="h4 dark-gold p-4 mt-4">If you wish to provide necessary items, please inform the Bhaddeka Vihari Monastery and Meditation Center office.</p>
    <p className="h4 dark-gold p-4 mt-4">For anyone wishing to contribute a monetary fund for the ongoing maintenance work, this will greatly help in purchasing the necessary items needed for the tasks.</p>
    <p className="h4 dark-gold p-4 mt-4">Thank you for your generosity and support!</p>

    <div className="text-center">
      <p className="h4 mt-6">Respect the Sangha, moral and wise,</p>
      <p className="h4 mt-4">Walking along the path, go beyond.</p>
      <p className="h4 mt-4">Enduring, realize the truth—</p>
      <p className="h4 mt-4">Sadhu! May they flourish fast.</p>


      <p className="h4 mt-6">Sangha, the merit field, harvest grown,</p>
      <p className="h4 mt-4">Let us gather to make them home.</p>
      <p className="h4 mt-4">Let us renovate, fix the worn,</p>
      <p className="h4 mt-4">Reap the yield, our spirits glow.</p>

    </div>


    <div className='btn-group2 mt-6'>
              <img src={imageFour1} alt="Right Top Image" width={300} />
              <img src={imageFive1} alt="Right Top Image" width={300} />
          </div>

        

      
    
          <div className="p-4 mt-6 text-center">
          <div className="mt-6 calander-box align-item-center">
                  <div className="c-details text-left">
                      <h2 className='intro-text '>Futher More Details : </h2>
                      <p className="font-p mt-4">Monastery : 035608 0918 / 0459 729 738</p>
                      <p className="font-p">Mr Gamini : 0422 069 359</p>
                      <p className="font-p">WhatsApp : 0422 069 359</p>
                      <p className="font-p">E-mail : info@bvp.org.au</p>
                  </div>
                  <div className="d-button">
                  <img
          src={imageSix}
          alt="Right Top Image"
          width={300}
          id="maintananceRequest"
          onClick={handleClick}
          className="curser-pointer"
        />
                    </div>
              </div>
              </div>

              <div className="bottom-box mt-6">
              <img src={imageThree} alt="bottom-image"  width={600} />
          </div>
   

    
  </div>
  )
}

export default MaintenanceHermitage